import { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, Tooltip, InputGroup, OverlayTrigger } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom'
import './CampaignStyles.css'
import { templateList } from '../Misc/Templates';
//import { TextInput, SelectInput } from '../Misc/FormInput';
import DataTable from 'react-data-table-component';
import { TempGrid } from './Grid';
import { usePresence } from '../../hooks/campaign/usePresence';
import { CampaignGrid } from '../_Campaign/Grid/CampaignGrid';
//import ProductForm from '../Products/ProductForm';
import { Search } from 'react-bootstrap-icons'
//import { CampaignProductForm } from './CampaignProductForm';
import CampaignProductFormRefactor from './CampaignProductForm';
import { getUserInfo } from '../Auth/fetchUser';
//import { TextInput } from '../Misc/FormInput';
//import CampaignProductTable from './CampaignProductTable';
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';
import useCampaignLeave from '../../hooks/campaign/useCampaignLeave';

function getPageTemplates(location, pages, defaultTemplate) {
    let pageTemplates = null
    if (location.pageTemplates) {
        pageTemplates = location.pageTemplates;
    } else {
        pageTemplates = {}
        for (let i = 1; i <= pages; i++) {
            pageTemplates[`${i}`] = defaultTemplate;
        }
    }
    return pageTemplates;
}





const Campaign = () => {
    const { instance } = useMsal();
    // Set user info
    const [userName, setUserName] = useState('');
    useEffect(() => {
        const userInfo = getUserInfo(instance);
        setUserName(userInfo.name);
    }, [instance]);

    const defaultProductFormState = {"sku": "", "manufacturer_num": "", "in_stock_sku_list": "", "display_sku": "", "name": "", "brand_id": 0, "brand_id_2": 0, "brand_id_3": 0, "brand_id_4": 0, "vendor_id": "", "sale_header": "", "save": "", "regular_price": "", "sale_price": "", "regular_price_map": "", "sale_price_map": "", "image_name": "", "bullet1": "", "bullet2": "", "bullet3": "", "bullet4": "", "bullet5": "", "disclaimer": "", "comments": "", "coop_vendor_code": "", "coop_comments": "", "hint": "", "hires_image_name": "", "hires_image_name_2": "", "hires_image_name_3": "", "coop_pre_approval": false, "product_id": "", "coop_eligible": "NO Co-op program", "buyer_responsible": '', "product_finalized": false}
    const navigate = useNavigate();

    // Fetch brands to create brand select inputs
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        authFetch(instance, '/api/fetch_brands')
        .then((res) => {
            return res.json();
        })
        .then((data) => {
            setBrands(data);
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }, []);

    const [vens, setVens] = useState({});
    useEffect(() => {
        authFetch(instance, '/api/fetch_full_vens')
        .then((res) => {
            return res.json();
        })
        .then((data) => {
            setVens(data);
        /*}).then(() => {
            console.log(vens);*/
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }, []);

    const location = useLocation()['state'];
    //console.log(location);

    // Set the campaignId
    const campaignId = location.campaignId ? location.campaignId : '';
    //console.log(campaignId);
    // Set the name of the campaign
    const [name, setName] = useState(location.name ? location.name : 'NEW CAMPAIGN');
    // Set the number of pages
    let tempPages = location.pages ? location.pages : 3;
    const [pages, setPages] = useState(tempPages);
    // Set the default template
    let template = location.template ? location.template : "1x4x4";
    const [pageTemplates, setPageTemplates] = useState(getPageTemplates(location, pages, template));

    // Set the start and end dates
    const [startDate, setStartDate] = useState(location.campaignStartDate ? location.campaignStartDate : new Date(2024, 1, 31));
    const [endDate, setEndDate] = useState(location.campaignEndDate ? location.campaignEndDate : new Date(2024, 1, 31));
    
    // Set the year
    const [year, setYear] = useState(location.year ? location.year : '')

    // Set the templates for each page
    const [page, setPage] = useState(1);

    const [products, setProducts] = useState(location.campaignProducts ? location.campaignProducts : {
    });

    const [selected, setSelected] = useState('');

    const [showLayoutSelector, setShowLayoutSelector] = useState(false);

    const [showSearch, setShowSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [isEmerchExporting, setIsEmerchExporting] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [useExact, setUseExact] = useState(false);
    const [showForm, setShowForm] = useState(false);

    // Functionality to display what users are in a grid
    const { activeGrids, updatePresence, deletePresence } = usePresence(instance, campaignId, userName);

    useCampaignLeave(selected, userName, campaignId, page, deletePresence);
    
    useEffect(() => {
        setProductFormState({...defaultProductFormState, 'buyer_responsible': ''});
        setSearchTerm('');
        setSearchResults([]);
        if (selected && `${page}page${selected}` in products) {
            setShowSearch(false);
            setShowForm(true);
            const tempProduct = products[`${page}page${selected}`];
            if (tempProduct['name'] === 'DO NOT USE - Product Needs Multiple Boxes') {
                setProductFormState({
                    ...tempProduct,
                    vendor_id: '',
                    coop_vendor_code: '',
                });
            } else {
                setProductFormState({ ...products[`${page}page${selected}`] });
            }
            updatePresence(`${page}page${selected}`);
        } else if (selected) {
            setShowSearch(true);
            setShowForm(false);
            updatePresence(`${page}page${selected}`);
        } else {
            setShowSearch(false);
            setShowForm(false);
            deletePresence(`${page}page${selected}`);
        }
        console.log(selected);
    }, [selected, page, products]);

    

    const [productFormState, setProductFormState] = useState(defaultProductFormState);

    const handleProductFormChange = (event) => {
        const { target: {name, value} } = event;
        if (name === 'sku' && (productFormState.in_stock_sku_list === '' || productFormState.in_stock_sku_list === productFormState.sku)) {
            console.log('changing in_stock_sku_list');
            setProductFormState({...productFormState, [name]: value, 'in_stock_sku_list': value});
        } else if (name === "coop_pre_approval") {
            let coop_pre_approval = !productFormState.coop_pre_approval;
            setProductFormState({...productFormState, [name]: coop_pre_approval});
        } else if (name === "product_finalized") {
            let product_finalized = !productFormState.product_finalized;
            setProductFormState({...productFormState, [name]: product_finalized});
        } else {
            setProductFormState({...productFormState, [name]: value});
        }
    }

    function saveProduct(productToSave = productFormState) {
        //console.log(productFormState.product_id);
        //console.log(productFormState);
        const isLegacy = productToSave.product_id === 0;
        authFetch(instance, '/api/save_product_to_campaign', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"campaignId": campaignId, "gridId": `${page}page${selected}`, "product": productToSave, "legacy": isLegacy})}
        ).then(function(res) {
            if (!res.ok) {
                alert('There was an error connecting to the database, please refresh the page.');
                return;
            }
            return res.json();
        }).then(function(data) {
            if (!data) return;
            // If backend returned a product_id (new product created), update the form state
            let updatedProduct = {...productToSave};
            if (data.product_id && data.product_id > 0) {
                updatedProduct.product_id = data.product_id;
            }
            setProductFormState(updatedProduct);
            setProducts({...products, [`${page}page${selected}`]: updatedProduct});
            setSelected('');
            alert('Product saved.');
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
        //selectProduct(productFormState);
    }

    function searchProducts(searchTerm) {
        //console.log(searchTerm);
        setShowLoading(true);
        authFetch(instance, '/api/search_products', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"searchTerm": searchTerm, "exact": useExact}),
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            //console.log(data);
            setSearchResults(data);
            setShowLoading(false);
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function updatePageTemplates(changePage, changeTemplate) {
        let campaignData = {"page": changePage, "template": changeTemplate, "campaignId": campaignId};
        authFetch(instance, '/api/save_page_template', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify(campaignData),
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                console.log(data);
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function deleteCampaign() {
        authFetch(instance, '/api/delete_campaign', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"campaignId": campaignId}),
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            navigate('/');
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function deleteProduct() {
        authFetch(instance, '/api/clear_campaign_product', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"campaignId": campaignId, "gridId": `${page}page${selected}`}),
        }).then(function(res) {
            setProducts((prevProducts) => {
                const tempProducts = { ...prevProducts };
                delete tempProducts[`${page}page${selected}`];
                return tempProducts;
            });
            setSelected('');
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
        
    }

    function coopExport() {
        authFetch(instance, '/api/export_coop', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"products": products, "templates": pageTemplates, "pages": pages}),
        }).then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `${name}_coop.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Error processing coop export...'));
    }

    function emerchExport() {
        setIsEmerchExporting(true);
        authFetch(instance, '/api/export_emerch', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"products": products, "pages": pages, "templates": pageTemplates}),
        }).then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `${name}_emerch.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Error processing Emerch export...'))
        .finally(() => setIsEmerchExporting(false));
    }

    function xmlExport(mode) {
        console.log('Exporting to XML');
        let campaignData = {"pages": pages, "templates": pageTemplates, "products": products, "mode": mode, "name": name}
        if (mode === 'page' || mode === 'page map' || mode === 'regular page') {
            campaignData["page"] = page;
        }
        console.log(campaignData);
        authFetch(instance, '/api/export_xml', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify(campaignData)
        })
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            if (mode === 'each' || mode === 'each map') {
                console.log('zip');
                a.download = `${name}_pages.zip`;
            } else if (mode === 'regular page') {
                a.download = `${name}_page_${page}.xml`;
            } else {
                a.download = `${name}.xml`;
            }
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Error processing XML'));
    }

    const tipPopup = (message) => {
        return (
            <Tooltip id="tooltipPopup" className="product-popup">
                <Container>
                    <Row>
                        <p>{message}</p>
                    </Row>
                </Container>
            </Tooltip>
        )
    }

    const renderProductPopup = (id) => {
        //console.log(id)
        if (`${page}page${id}` in products) {
            return (
                <Tooltip id="productPopUp" className="product-popup">
                    <Container>
                        <Row>
                            <b>{products[`${page}page${id}`]['name']}</b>
                            <p>SKU/Item #: {products[`${page}page${id}`]['sku']}</p>
                            <p>Printed SKU/Item #: {products[`${page}page${id}`]['display_sku']}</p>
                            <p>MFR #: {products[`${page}page${id}`]['manufacturer_num']}</p>
                            {/*<p>Brand: {products[`${page}page${id}`]['brand']}</p>*/}
                            <p>Regular Price: {products[`${page}page${id}`]['regular_price']}</p>
                            <p>Sale Price: {products[`${page}page${id}`]['sale_price']}</p>
                        </Row>
                    </Container>
                </Tooltip>
            )
        } else {
            return (
                <Tooltip id="productPopUp" className="product-popup">
                    <Container>
                        <Row>
                            <b>No Product Selected</b>
                        </Row>
                    </Container>
                </Tooltip>
            )
        }
    }

    const [updateName, setUpdateName] = useState('');
    const [showUpdateName, setShowUpdateName] = useState(false);
    function callUpdateName() {
        authFetch(instance, '/api/update_campaign_name', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"name": updateName, "year": year, "campaignId": campaignId}),
        }).then(function(res) {
            setName(updateName);
            setUpdateName('');
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function saveDates() {
        authFetch(instance, '/api/update_campaign_dates', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                campaignId: campaignId,
                startDate: startDate,
                endDate: endDate
            })
        }).then(response => {
            console.log('Date save response:', response); 
        }).catch(error => {
            alert('Error updating dates');
        });
    }

    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        if (startDate && endDate && campaignId && !isInitialLoad) {
            saveDates();
        }
        setIsInitialLoad(false);
    }, [startDate, endDate])

    function disableBox(box, page, disable=true) {
        if (disable) {
            authFetch(instance, '/api/disable_box', {
                "method": "POST",
                "headers": {"Content-Type": "application/json"},
                "body": JSON.stringify({"campaignId": campaignId, "gridId": `${page}page${box}`})
            }).then(function(res) {
                const disabledFormState = {
                    ...defaultProductFormState,
                    name: 'DO NOT USE - Product Needs Multiple Boxes',
                };
                setProducts({...products, [`${page}page${selected}`]: disabledFormState});
            }).catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
            });
        } else {
            deleteProduct();
        }
    }

    const [newPageTemplate, setNewPageTemplate] = useState(pageTemplates[`${page}`]);
    function addPage() {
        authFetch(instance, '/api/add_page', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"page": pages+1, "template": newPageTemplate, "campaignId": campaignId, "pages": pages+1})
        }).then(function(res) {
            setPageTemplates({...pageTemplates, [`${pages+1}`]: newPageTemplate});
            setPages(pages+1);
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    return (
        <Container>
            
            <Row>
                <Col xs={6}>
                    <h2 className="text-start">{name}</h2>
                </Col>
                <Col xs={6}>
                    <Row>
                        <Form.Group className="text-end d-flex">
                            <Col className="d-grid offset-3">
                                <Button
                                    style={{backgroundColor: "#918865",
                                        borderRadius: "0px",
                                        borderColor: "#918865",
                                        marginRight: "10px"}}
                                    disabled={isEmerchExporting}
                                    onClick={() => emerchExport()}>
                                    {isEmerchExporting ? 'Exporting eMerch…' : 'eMerch export'}
                                </Button>
                            </Col>
                            <Col className="d-grid">
                                <Button
                                    style={{backgroundColor: "#433911",
                                        borderRadius: "0px",
                                        borderColor: "#433911",
                                        marginRight: "10px"}}
                                    className='btn btn-block'
                                    onClick={() => coopExport()}>
                                    Co-op
                                </Button>
                            </Col>
                            <Col className={"text-end "+(showLayoutSelector ? 'd-grid' : 'd-none')}>
                                <Button
                                    style={{backgroundColor: "#000000",
                                        borderRadius: "0px",
                                        borderColor: "#000000"}}
                                    className='btn btn-block'
                                    onClick={() => deleteCampaign()}>
                                    Delete Campaign
                                </Button>
                            </Col>
                        </Form.Group>
                    </Row>
                </Col>
                {year && <Row>
                    <Col xs={6}>
                        <p className="text-start">Year: {year}</p>
                    </Col>
                </Row>}
                {/* EDIT CAMPAIGN NAME AND YEAR */}
                <Row className='mb-2 align-items-center' style={{display: showUpdateName ? "" : "none"}}>
                    <Col xs={3} className="text-start">
                        <input value={updateName} placeholder={name} style={{width: "100%", height: "100%"}} onChange={(e) => setUpdateName(e.target.value)}></input>
                    </Col>
                    <Col xs={5} className="text-start">
                        <Button style={{backgroundColor: "#a73c21",
                                        borderRadius: "0px",
                                        borderColor: "#a73c21"}}
                        onClick={() => {callUpdateName();setShowUpdateName(!showUpdateName)}}>
                            Update Name & Year
                        </Button>
                    </Col>
                </Row>
                <Row className='mb-2 align-items-center' style={{display: showUpdateName ? "" : "none"}}>
                    <Col xs={3} className="text-start">
                        <input value={year} placeholder={`Campaign year... (${new Date().getFullYear()})`} style={{width: "100%", height: "100%"}} onChange={(e) => setYear(e.target.value)}></input>
                    </Col>
                </Row>
                <Row className="mb-3 text-start">
                    <Col xs={2}>
                        <Form.Control value={startDate} type="date" id="startDate" onChange={(e) => setStartDate(e.target.value)}></Form.Control>
                    </Col>
                    <Col xs={2}>
                        <Form.Control value={endDate} type="date" id="endDate" onChange={(e) => setEndDate(e.target.value)}></Form.Control>
                    </Col>
                </Row>
                <hr/>
                <Col xs={5} style={{paddingRight: "30px"}}>
                    <h4 style={{textAlign: "start"}}>STEP 1: Select page and product box</h4>
                    <br/>
                    <Col lg={3} xs={3} style={{display: 'inline'}}>
                        <Form>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column xs={3}>Page</Form.Label>
                                <Col xs={3}>
                                    <Form.Select id="page" onChange={(e) => setPage(e.target.value)}>
                                        {[...Array(parseInt(pages))].map((x, i) => <option value={i+1} key={i+1}>{i+1}</option>)}
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Form>
                    </Col>
                    <Row className="mb-4">
                        <Col xs={12} className="border border-dark">
                            {/*<TempGrid
                                template={pageTemplates[page]}
                                selectFunc={(id)=> {id===selected ? setSelected('') : setSelected(id)}}
                                selected={selected}
                                hoverFunc={(id) => renderProductPopup(id)}
                                products={products}
                                page={page}
                                activeGrids={activeGrids}
                            />*/}
                            <CampaignGrid
                                template={pageTemplates[page]}
                                selectFunc={(id)=> {id===selected ? setSelected('') : setSelected(id)}}
                                selected={selected}
                                hoverFunc={(id) => renderProductPopup(id)}
                                products={products}
                                page={page}
                                activeGrids={activeGrids}
                                currentUser={userName}
                            />
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <h5 style={{textAlign: "start"}}>For Design ONLY</h5>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Editing page layouts may cause loss of product data, do not use these features without approval from design.")}
                            >
                            <Button style={{ backgroundColor: "#a73c21", border: "none", borderRadius: "0"}} onClick={() => {setShowLayoutSelector(!showLayoutSelector);setShowUpdateName(!showUpdateName);setUpdateName('');setNewPageTemplate(pageTemplates[`${page}`]);}}>Edit page layout</Button>
                            </OverlayTrigger>
                        </Col>
                        <Col xs={6} className="d-grid">
                            <Form.Select id="templateSelector" value={pageTemplates[`${page}`]} onChange={(e) => {setPageTemplates({...pageTemplates, [`${page}`]: e.target.value});updatePageTemplates(page, e.target.value)}} style={{display: showLayoutSelector ? 'block' : 'none'}}>
                                {templateList.map((templateOption) => <option value={templateOption.name} key={templateOption.name}>{templateOption.name==="4x4x4"
                                ? "4x4x4 (Covers)"
                                : templateOption.name}</option>)}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2" style={{display: showLayoutSelector ? '' : 'none'}}>
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Add a page to the end of the flyer, use the selector to the right of the Add Page button to choose the template for the new page.")}
                            >
                            <Button type='button' style={{ backgroundColor: "#a73c21", border: "none", borderRadius: "0"}}
                            onClick={() => addPage()}>Add Page</Button>
                            </OverlayTrigger>
                        </Col>
                        <Col xs={6} className="d-grid">
                            <Form.Select id="templateSelector" value={newPageTemplate} onChange={(e) => setNewPageTemplate(e.target.value)}>
                                {templateList.map((templateOption) => <option value={templateOption.name} key={templateOption.name}>{templateOption.name==="4x4x4"
                                ? "4x4x4 (Covers)"
                                : templateOption.name}</option>)}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                        <OverlayTrigger
                            overlay={tipPopup("Export XML using Standard pricing for entire flyer")}>
                            <Button style={{ backgroundColor: "#433911", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("regular")}>Export XML</Button>
                        </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                        <OverlayTrigger
                            overlay={tipPopup("Export XML using Standard pricing for single page")}>
                            <Button style={{ backgroundColor: "#433911", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("regular page")}>Export Page XML</Button>
                        </OverlayTrigger>
                        </Col>
                    </Row>
                    {/*<Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Export XML using MAP pricing (regular product pricing will not be used)")}
                            >
                            <Button style={{ backgroundColor: "#918865", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("map")}>Export XML (MAP Pricing)</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>*/}
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Export sale sign XML for this page using standard pricing")}
                            >
                            <Button style={{ backgroundColor: "#918865", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("page")}>Export Sale Page</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Export sale sign XML for this page using MAP pricing")}
                            >
                            <Button style={{ backgroundColor: "#918865", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("page map")}>Export Sale Page (MAP Pricing)</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Export all pages to XML in a ZIP archive")}
                            >
                            <Button style={{ backgroundColor: "#433911", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("each")}>Export Sale Signs</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row className="text-start mb-2">
                        <Col xs={6} className="d-grid">
                            <OverlayTrigger
                                overlay={tipPopup("Export all pages to XML using MAP pricing in a ZIP archive")}
                            >
                            <Button style={{ backgroundColor: "#433911", border: "none", borderRadius: "0"}}
                            onClick={() => xmlExport("each map")}>Export Sale Signs (MAP Pricing)</Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </Col>
                <Col xs={7} className="border-start">
                    <Row>
                        <Col xs={7}>
                            <h4 style={{textAlign: "start"}}>{
                                (selected && `${page}page${selected}` in products)
                                    ? (!(`${page}page${selected}` in products && products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes')
                                    ? "Step 2: EDIT and SAVE product"
                                    : "BOX DISABLED")
                                    : selected
                                        ? "Step 2: Search Products"
                                        : "Step 2: Select a product"
                                }
                            </h4>
                        </Col>
                        <Col>
                            <Button
                                style={{backgroundColor: "#a73c21",
                                    borderRadius: "0px",
                                    borderColor: "#a73c21",
                                    display: (`${page}page${selected}` in products
                                        ? ((products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes')
                                        ? "none"
                                        : "inline")
                                    : "none"
                                    )}}
                                onClick={() => deleteProduct()}>
                                    Clear Product
                                </Button>
                                <Button
                                style={{backgroundColor: "#a73c21",
                                    borderRadius: "0px",
                                    borderColor: "#a73c21",
                                    display: ((selected !== '' && !(`${page}page${selected}` in products))
                                        ? "inline"
                                        : "none"
                                    )}}
                                onClick={() => {
                                    setShowForm(!showForm);setShowSearch(!showSearch);
                                    let newProductState = {...defaultProductFormState, buyer_responsible: userName || ''};
                                    setProductFormState(newProductState);
                                    //setProductFormState(defaultProductFormState);

                                }}>
                                    {showSearch ? "New Product" : "Search Products"}
                                </Button>
                        </Col>
                        <Col style={{display: selected 
                            ? (showUpdateName ? '' : 'none') : 'none'}}>
                            <Button style={{
                                backgroundColor: 
                                    ((`${page}page${selected}` in products && products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes')
                                    ? "#a73c21"
                                    : "#000000"),
                                borderRadius: "0px",
                                borderColor: "#a73c21"
                            }}
                            onClick={() => {disableBox(selected, page, !(`${page}page${selected}` in products && products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes'))}}>
                                {(`${page}page${selected}` in products && products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes')
                                    ? "Enable Box"
                                    : "Disable Box"}
                            </Button>
                        </Col>
                        
                    </Row>
                    <div style={{display: (showForm ? (
                        !(`${page}page${selected}` in products && products[`${page}page${selected}`]['name'] === 'DO NOT USE - Product Needs Multiple Boxes') ?
                            "block"
                            : "none") : "none")}}>
                        <hr/>
                        <CampaignProductFormRefactor
                            productFormState={productFormState}
                            handleProductFormChange={handleProductFormChange}
                            saveProduct={saveProduct}
                            brands={brands}
                            isNew={selected !== '' && !(`${page}page${selected}` in products)}
                            setProductFormState={setProductFormState}
                            vens={vens}
                            selected={selected}
                            buyer_responsible={userName}
                        />
                    </div>
                    <div style={{display: (showSearch ? "inline" : "none")}}>
                        <Row className="align-items-center">
                            <Col xs={7} >
                                <InputGroup>
                                    <Form.Control type="text"
                                        placeholder="Search for SKU, Manufacturer Number, Name..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" ? searchProducts(searchTerm) : {}}
                                    />
                                    <Button
                                        style={{backgroundColor: "#a73c21",
                                            borderRadius: "0px",
                                            borderColor: "#a73c21"}}
                                        onClick={() => {searchProducts(searchTerm)}}>
                                        <Search/>
                                    </Button>
                                </InputGroup>
                                <InputGroup>
                                    <Form.Check value={useExact} onChange={() => {setUseExact(!useExact);}}></Form.Check>
                                    &nbsp;&nbsp;
                                    <Form.Label name="exactLabel">Exact match</Form.Label>
                                </InputGroup>
                            </Col>
                            <Col xs={4} className='text-start' style={{display: (showLoading ? "block" : "none")}}>
                                <p>Searching for products...</p>
                            </Col>
                        </Row>
                    </div>
                    {/*<div style={{display: (searchResults.length > 0 ? "block" : "none")}}>*/}
                    <div style={{display: (showSearch ? "block" : "none")}}>
                        <DataTable
                            columns={[
                                {
                                    name: 'Name',
                                    //selector: row => row.name,
                                    cell: row => 
                                        <div className='cell-text-wrap'>{row.name}</div>,
                                    sortable: true,
                                    wrap: true
                                },
                                {
                                    name: 'SKU',
                                    //selector: row => row.sku,
                                    cell: row =>
                                        <div className='cell-text-wrap'>{row.sku}</div>,
                                    sortable: true
                                },
                                {
                                    name: 'MFR',
                                    //selector: row => row.manufacturer_num,
                                    cell: row =>
                                        <div className='cell-text-wrap'>{row.manufacturer_num}</div>,
                                    sortable: true
                                },
                                {
                                    name: 'Hint',
                                    cell: row =>
                                        <div className='cell-text-wrap'>{row.hint}</div>,
                                    sortable: true
                                },
                                {
                                    name: "Modified",
                                    selector: row => row.modifiedDate.split('.')[0],
                                    sortable: true
                                }
                            ]}
                            data={searchResults}
                            /*onRowClicked={(product) => setProducts({...products, [`${page}page${selected}`]: product})}*/
                            onRowClicked={(product) => {setProductFormState({...product, buyer_responsible: userName || ''});setShowForm(true);setShowSearch(false);setSearchTerm('');setSearchResults([]);}}
                            pagination
                            highlightOnHover
                            striped
                        />
                    </div>
                </Col>
            </Row>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </Container>
    );
}
 
export default Campaign;
